import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { takeWhile } from 'rxjs';
import { PartnerDataModel } from 'src/app/account/models/accountModel';
import { AccountService } from 'src/app/account/services/account.service';

@Component({
  selector: 'app-menu-bar',
  templateUrl: './menu-bar.component.html',
  styleUrls: ['./menu-bar.component.scss']
})
export class MenuBarComponent implements OnInit, OnDestroy {

  destroySubscription = false;

  selectedMobMenu = 'Home';

  isMenuOpen = false;

  partialLoggedIn: boolean;

  user: PartnerDataModel;

  isCustomerUser = false;

  constructor(private accountService: AccountService) {
    this.accountService.partialLoggedIn.pipe(takeWhile(() => !this.destroySubscription))
      .subscribe((response: any) => {
        if (response) {
          this.partialLoggedIn = response;
        } else {
          this.partialLoggedIn = false;
        }
      });
  }

  ngOnInit(): void {
    this.user = this.accountService.getUser() ? this.accountService.getUser() : null;
    console.log('user', this.user);
    if (this.user && this.user.customer_name) {
      this.isCustomerUser = true;
    }
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  closeMenu() {
    this.isMenuOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!(event.target as HTMLElement).classList.contains('hamburger-icon')) {
      this.closeMenu();
    }
  }

  ngOnDestroy(): void {
    this.destroySubscription = true;
  }

}
